export const PREV_PATH_STORAGE_KEY = "prevPath";

export function usePrevPath() {
	if (typeof window === "undefined") {
		return null;
	}

	return window.sessionStorage.getItem(PREV_PATH_STORAGE_KEY);
}
